import React, { lazy, Suspense } from 'react';

const MuiCalendar = lazy(() => import('./index'));

const WrappedCalendar = (props) => (
  <Suspense fallback={<div>Loading...</div>}>
    <MuiCalendar {...props} />
  </Suspense>
);

export default WrappedCalendar;
